import {
  Component,
  OnInit, SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { formatDate } from '@angular/common';
import {DataSharingService} from '../../services/data-sharing/data-sharing.service';

@Component({
  selector: 'app-ride-leasing-rahmenbedingungen',
  templateUrl: './ride-leasing-rahmenbedingungen.component.html',
  styleUrls: ['./ride-leasing-rahmenbedingungen.component.scss'],
})
export class RIDELeasingRahmenbedingungenComponent
  implements OnInit
{
  @ViewChild('datetime', { static: false }) dateTime;
  viewEncapsulation = ViewEncapsulation.Emulated;



  public JaNeinList = [
    { value: false, display: 'Nein' },
    { value: true, display: 'Ja' }
  ];
  public JaNeinListNumber = [
    { value: 0, display: 'Nein' },
    { value: 1, display: 'Ja' }
  ];
  public erwJaNeinList = [
    { value: 0, display: 'Nein' },
    { value: 1, display: 'Ja' },
    { value: 2, display: 'Ja, ab' },
  ];

  public minDate: string;
  public maxDate: string;
  private oldFairbetrag = 6;
  isNetto = false;
  private fairbetragChanged = false;
  constructor(public dSS: DataSharingService) {

  }



  ngOnInit() {
    const today = new Date();
    this.minDate = formatDate(today, 'yyyy-MM', 'en-US');
    const maxDatum = new Date();
    maxDatum.setFullYear(today.getFullYear() + 3);
    // Set the maxDate to the formatted date in 3 years
    this.maxDate = formatDate(maxDatum, 'yyyy-MM', 'en-US');

  }

  onDateTimeChange(event) {
    this.dSS.selectedDate = new Date(event.detail.value);
    this.dSS.inputChanged.next(false);
  }

  update(changes: any): void{

    this.dSS.inputChanged.next(true);
  }

  updateFairbetrag(event: any) {
    if (this.dSS.dienststelle.fairbetrag !== 0
      && event) {
      this.oldFairbetrag = this.dSS.dienststelle.fairbetrag;
      this.dSS.dienststelle.fairbetrag = 0;
    } else{

      this.dSS.dienststelle.fairbetrag = this.oldFairbetrag;
    }
    this.fairbetragChanged = true;
    this.dSS.inputChanged.next(true);

  }

  showFairbetrag() {
    if (this.dSS.dsCode === '' ) {
      return true;
    }
    if (this.dSS.bArt === 0 ) {
      return this.dSS.dienststelle.fairbetragBeamte;
    }else {
      return this.dSS.dienststelle.fairbetrag || this.fairbetragChanged;
    }

  }

  hasFairbetrag() {
    if (this.dSS.bArt === 0 ) {
      return !!(this.dSS.dienststelle.fairbetragBeamte);
    }else {
      return !!(this.dSS.dienststelle.fairbetrag);
    }

  }
}
